import cx from 'classnames';

interface TablePaginationButtonStylesProps {
  withIcon: boolean;
  selected: boolean;
  disabled: boolean;
  selectable: boolean;
}

export const getPageStylesAsClassNames = ({
  withIcon,
  selected,
  disabled,
  selectable,
}: TablePaginationButtonStylesProps): string => {
  return cx(
    'min-h-[32px]',
    'min-w-8',
    'p-1',
    'bg-transparent',
    'text-gray-dark',
    'rounded',
    {
      'bg-gray-light': selected,
      'cursor-[initial]': disabled,
      'text-gray-light': disabled,
      'leading-[0]': withIcon,
      'cursor-pointer hover:bg-gray-xlight':
        selectable && !disabled && !selected,
    }
  );
};
